import { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Switch } from "../ui/switch";
import { BRAND, errMsg } from "./constants";

export function FlatmateListCard({ property, authFetch, API, onSaved }) {
  const [on, setOn] = useState(!!property.flatmate_listed);
  const toggle = async (v) => {
    try {
      await authFetch({ method: "post", url: `${API}/homestay/properties/${property.id}/flatmate-listing`, data: { enabled: v } });
      setOn(v); toast.success(v ? "Your empty beds are now live on Flatmate" : "Removed from Flatmate"); onSaved?.();
    } catch (e) { toast.error(errMsg(e, "Could not update")); }
  };
  return (
    <div data-testid="flatmate-list-card" className="rounded-2xl border-2 bg-white p-4 flex items-center justify-between gap-4" style={{ borderColor: on ? BRAND.green : BRAND.line }}>
      <div>
        <div className="text-sm font-bold" style={{ color: BRAND.green }}>List my beds on Flatmate</div>
        <p className="text-xs" style={{ color: BRAND.muted }}>Every empty bed shows on the Flatmate "Beds available" strip. People tap a bed to request it — you approve in Requests & Care.
          {on && <> <Link to="/flatmate/browse" className="font-bold underline" data-testid="flatmate-list-preview" style={{ color: BRAND.orange }}>See it live</Link></>}</p>
      </div>
      <Switch data-testid="flatmate-list-toggle" checked={on} onCheckedChange={toggle} />
    </div>
  );
}
